<template>
  <div
    class="pt-6 hyp-content-details-container"
    :class="{ 'expanded-content': expandedContent }"
  >
    <div v-if="!isMinimized">
      <Loader
        v-if="
          !details &&
          (!selectedRiskSummaryType ||
            selectedRiskSummaryType.id !== riskSummaryCitiesId)
        "
        :text="loaderText"
        size="small"
        class="mt-5"
      ></Loader>

      <div
        v-if="details && selectedRiskSummaryType.id !== riskSummaryCitiesId"
        class="details-container"
        :class="containerClasses"
      >
        <v-row>
          <v-col cols="6" class="pt-0 col col-6 pl-6">
            <h1>
              <v-icon
                v-if="!isMinimized"
                size="18"
                @click="handleClickMinimize"
                title="Back to Map"
                class="mr-3"
                >fas fa-arrow-left</v-icon
              >
              {{ selectedLocation.name }}
            </h1>
          </v-col>
          <v-col cols="6" class="pt-0 pr-6 col col-6 text-right">
            <RisksCountryReport
              class="pl-2 pull-right"
              v-if="selectedLocation && !hideCountryReport"
              :selected-location="selectedLocation"
            ></RisksCountryReport>
            <v-btn
              @click="openLocationWatch"
              color="primary"
              v-if="!hasEssentials && isWatchCountry && !hideWatch"
              small
            >
              <span>Watch Location</span>
            </v-btn>
          </v-col>
        </v-row>

        <v-sheet>
          <v-tabs
            v-model="riskSummaryType"
            grow
            next-icon="mdi-arrow-right-bold-box-outline"
            prev-icon="mdi-arrow-left-bold-box-outline"
            show-arrows
          >
            <v-tab
              v-for="item in filteredRiskSummaryTypes"
              :key="item.id"
              :href="'#' + item.id"
              class="hyp-risk-tabs"
              @click="handleChangeRiskSummaryType(item)"
            >
              {{ item.label }}
            </v-tab>
          </v-tabs>
        </v-sheet>

        <v-container class="hyp-risk-details-container">
          <v-row>
            <v-col cols="12" class="pt-0">
              <!-- Risks -->
              <v-container
                class="hyp-risk-tab-items mt-3"
                v-if="this.selectedRiskSummaryType.riskRatingPrimary"
              >
                <v-row id="hyp-risk-grid">
                  <v-col
                    id="hyp-risk-content-wrapper"
                    cols="12"
                    class="pt-0 content-container"
                  >
                    <RisksContentContainerWrapper
                      class="hyp-risk-grid-left"
                      :wrapper-class="'mt-3 mr-3'"
                      wrapper-id="risks-headlines"
                      @refresh-content="refreshRiskCountryHeadlineContent"
                      :expand="refresh"
                      :reset-expanded="resetExpanded"
                      expand-btn-title="View in Full Page"
                    >
                      <RisksHeadlines
                        :selected-location="selectedLocation"
                        :params="countryRiskparams"
                        :analysis-only="analysisOnly"
                        @click-close="handleClickClose"
                        @click-minimize="handleClickMinimize"
                        @selected-tab="handleTabChange"
                        @selected-dates="handleDatesChange"
                        @selected-dates-by-user="handleDatesByUserChange"
                        @selected-sort="handleSortChange"
                        :selected-tab-index="selectedTabIndex"
                        :selected-tab-content="selectedTabContent"
                        :selected-tab-dates="selectedTabDates"
                        :selected-tab-dates-by-user="selectedTabDatesByUser"
                        :selected-sort="selectedSort"
                        :headline-params="params"
                        :key="refresh"
                      ></RisksHeadlines>
                    </RisksContentContainerWrapper>
                  </v-col>
                  <v-col>
                    <RisksContentContainerWrapper
                      class="mb-2 expand-left"
                      :wrapper-class="'mt-3 mr-3'"
                      wrapper-id="risks-pulse-ratings"
                      :reset-expanded="resetExpanded"
                      @click-expand="handleClickExpandPulse"
                      @click-collapse="handleClickCollapsePulse"
                      expand-btn-title="VIEW ALL ZONE &amp; SUB RISKS"
                    >
                      <RisksPulseRatings
                        v-if="selectedLocation"
                        :selected-location="selectedLocation"
                        :selected-primary-risk-category="category"
                        :risksContentExpanded="risksPulseRatingsExpanded"
                        :params="params"
                      ></RisksPulseRatings>
                    </RisksContentContainerWrapper>
                    <RisksContentContainerWrapper
                      class="mb-2 pa-3 hyp-risk-content-body expand-left"
                      wrapper-id="risks-content-body"
                      expand-btn-title="View in Full Page"
                      :reset-expanded="resetExpanded"
                      @click-expand="handleClickExpand"
                      @click-collapse="handleClickExpand(false)"
                    >
                      <RisksContentBody
                        v-if="showBodySections"
                        :title="title"
                        :body="body"
                        :publish-date="publishDate"
                        :risk-content="details.properties.formatted.riskContent"
                        :selected-primary-risk-category="category"
                        :main-overview="mainOverview"
                        :params="params"
                        :expanded-in-parent="expandedContent"
                        :show-more-link="
                          !category || category.riskCategoryName === 'security'
                        "
                        @expanded="handleClickExpand"
                      ></RisksContentBody>
                    </RisksContentContainerWrapper>
                    <RisksCalendarEvents
                      v-if="
                        selectedRiskSummaryType.id === riskSummaryOverviewId
                      "
                      class="calendar-events"
                      :selected-location="selectedLocation"
                    ></RisksCalendarEvents>
                    <RisksEvacuation
                      v-if="
                        selectedRiskSummaryType.id ===
                          riskSummarySecurityRiskId && !hideEvacuationWatch
                      "
                      :background="details"
                    ></RisksEvacuation>
                    <RisksPorts
                      v-if="
                        selectedRiskSummaryType.id === riskSummaryMaritimeId &&
                        portsInfo &&
                        hasMaritimeAccess
                      "
                      :selected-location="selectedLocation"
                      :ports-info="portsInfo"
                    ></RisksPorts>
                  </v-col>
                </v-row>
              </v-container>

              <!-- Profile -->
              <v-container
                class="hyp-risk-tab-items"
                v-if="selectedRiskSummaryType.id === riskSummaryProfileId"
              >
                <v-row>
                  <v-col cols="12">
                    <RisksProfiles :background="details"></RisksProfiles>
                  </v-col>
                </v-row>
              </v-container>

              <!-- Scenarios -->
              <v-container
                class="hyp-risk-tab-items"
                v-if="selectedRiskSummaryType.id === riskSummaryScenarioId"
              >
                <v-row>
                  <v-col cols="12">
                    <RisksScenarios
                      v-if="!isScenariosV2FeatureUnlocked"
                      :background="details"
                    ></RisksScenarios>
                    <RisksCountryScenarios
                      v-if="isScenariosV2FeatureUnlocked"
                      :selected-location="selectedLocation"
                    ></RisksCountryScenarios>
                  </v-col>
                </v-row>
              </v-container>
            </v-col>
          </v-row>
        </v-container>
      </div>
      <!-- Cities -->
      <RisksCitiesContent
        v-if="
          cities &&
          selectedRiskSummaryType &&
          selectedRiskSummaryType.id === riskSummaryCitiesId
        "
        :selected-location="selectedLocation"
        :cities="cities"
        @click-back-to-country="handleClickBackToCountry"
        @click-minimize="handleClickMinimize"
        @click-close="handleClickClose"
      ></RisksCitiesContent>
    </div>
  </div>
</template>

<script>
import lodashGet from "lodash/get";
import lodashFind from "lodash/find";
import lodashMap from "lodash/map";
import lodashMethod from "lodash/method";
import lodashCloneDeep from "lodash/cloneDeep";
import lodashOrderBy from "lodash/orderBy";

import {
  getCountryDetails,
  getRiskRatingsByCountryCode,
} from "@/services/controlRisks/risks.service";
import { RISK_RATING_PRIMARIES } from "@/common/constants/controlRisks/risks";
import {
  RISK_SUMMARY_TYPES,
  RISK_SUMMARY_TYPE_OVERVIEW_ID,
  RISK_SUMMARY_TYPE_SECURITY_RISK_ID,
  RISK_SUMMARY_TYPE_PROFILE_ID,
  RISK_SUMMARY_TYPE_SCENARIO_ID,
  RISK_SUMMARY_TYPE_MARITIME_ID,
  RISK_SUMMARY_TYPE_CITIES_ID,
} from "@/common/constants/controlRisks/riskSummaryTypes.js";
import {
  hasEssentialsAccess,
  hasMaritimeAccess,
} from "@/services/user/user.service";
import { getAllCountries, getCountries } from "@/common/maps/utilities";
import { EVENT_ACTIONS, EVENT_CATEGORIES } from "@/common/constants/analytics";
import { DETAIL_SIDEBAR_TYPES } from "@/common/constants/home";
import { GRIDS_STABILITY_TYPES } from "@/common/constants/grids";
import { MODULE_PREFIX_HOME } from "@/store";
import { GET_DETAILS_SIDEBAR } from "@/store/actions.type";
import { mapGetters } from "vuex";

const EMITTED_ACTIONS = {
  CLICK_CLOSE: "click-close",
  CLICK_MINIMIZE: "click-minimize",
};

export default {
  name: "RisksContent",
  components: {
    Loader: () => import("@/components/common/Loader"),
    RisksCountryReport: () =>
      import("@/components/controlRisks/risks/RisksCountryReport"),
    RisksContentContainerWrapper: () =>
      import("@/components/controlRisks/risks/RisksContentContainerWrapper"),
    RisksHeadlines: () =>
      import("@/components/controlRisks/risks/RisksHeadlines"),
    RisksPulseRatings: () =>
      import("@/components/controlRisks/risks/RisksPulseRatings"),
    RisksContentBody: () =>
      import("@/components/controlRisks/risks/RisksContentBody"),
    RisksCalendarEvents: () =>
      import("@/components/controlRisks/risks/RisksCalendarEvents"),
    RisksEvacuation: () =>
      import("@/components/controlRisks/risks/RisksEvacuation"),
    RisksScenarios: () =>
      import("@/components/controlRisks/risks/RisksScenarios"),
    RisksCountryScenarios: () =>
      import("@/components/controlRisks/risks/RisksCountryScenarios"),
    RisksProfiles: () =>
      import("@/components/controlRisks/risks/RisksProfiles"),
    RisksPorts: () => import("@/components/controlRisks/risks/RisksPorts"),
    RisksCitiesContent: () =>
      import("@/components/controlRisks/risks/RisksCitiesContent"),
  },
  props: {
    selectedLocation: {
      type: Object,
    },
    isMinimized: {
      type: Boolean,
      default: false,
    },
    params: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    const hideEvacuationWatch = lodashGet(this.params, "hideEvacuationWatch")
      ? lodashGet(this.params, "hideEvacuationWatch")
      : false;
    const hideWatch = lodashGet(this.params, "hideWatch")
      ? lodashGet(this.params, "hideWatch")
      : false;
    const hideCountryReport = lodashGet(this.params, "hideCountryReport")
      ? lodashGet(this.params, "hideCountryReport")
      : false;
    return {
      hasEssentials: hasEssentialsAccess(),
      riskSummaryType: null,
      selectedRiskSummaryType: null,
      details: null,
      body: null,
      title: null,
      publishDate: null,
      bodyItems: null,
      showBodySections: false,
      category: null,
      selectedPrimaryRiskOverview: null,
      ratings: null,
      zones: null,
      loadingRisks: false,
      expandedContent: false,
      resetExpanded: null,
      risksPulseRatingsExpanded: null,
      risksContentBodyExpanded: null,
      watchCountries: [],
      countries: [],
      refresh: 0,
      selectedTabIndex: 0,
      selectedTabContent: null,
      selectedTabDates: {},
      selectedTabDatesByUser: false,
      selectedSort: null,
      riskSummaryOverviewId: RISK_SUMMARY_TYPE_OVERVIEW_ID,
      riskSummarySecurityRiskId: RISK_SUMMARY_TYPE_SECURITY_RISK_ID,
      riskSummaryScenarioId: RISK_SUMMARY_TYPE_SCENARIO_ID,
      riskSummaryProfileId: RISK_SUMMARY_TYPE_PROFILE_ID,
      riskSummaryMaritimeId: RISK_SUMMARY_TYPE_MARITIME_ID,
      riskSummaryCitiesId: RISK_SUMMARY_TYPE_CITIES_ID,
      mainOverview: {},
      hideEvacuationWatch: hideEvacuationWatch,
      hideWatch: hideWatch,
      hideCountryReport: hideCountryReport,
      portsInfo: null,
    };
  },
  async mounted() {
    this.selectedRiskSummaryType = lodashCloneDeep(
      this.filteredRiskSummaryTypes[0]
    );
    this.watchCountries = await getAllCountries();
    this.countries = await getCountries();
  },
  computed: {
    ...mapGetters({
      detailsSidebar: MODULE_PREFIX_HOME + "detailsSidebar",
    }),
    containerClasses() {
      const classes = {};
      const selected =
        "selected-" + this.selectedRiskSummaryType.label.replace(" ", "-");
      classes[selected] = true;
      classes["has-ports"] = !!this.portsInfo;
      return classes;
    },
    iso2Code() {
      if (this.selectedLocation && this.selectedLocation.iso2Code) {
        return this.selectedLocation.iso2Code;
      }
      return null;
    },
    loaderText() {
      const selectedText =
        this.selectedLocation && this.selectedLocation.name
          ? this.selectedLocation.name
          : "";
      return `Loading ${selectedText} details`;
    },
    cities() {
      const cities = lodashFind(this.countries, [
        "isoAlpha2Code",
        this.selectedLocation?.iso2Code,
      ])?.cities?.filter((city) => city.inRiskRatings);
      return cities?.length > 0
        ? lodashOrderBy(cities, ["name"], ["asc"])
        : null;
    },
    filteredRiskSummaryTypes() {
      return lodashCloneDeep(RISK_SUMMARY_TYPES).filter((tag) => {
        if (
          (tag.riskRatingPrimary !== RISK_RATING_PRIMARIES.maritime ||
            (tag.riskRatingPrimary === RISK_RATING_PRIMARIES.maritime &&
              this.hasMaritime)) &&
          (tag.id !== this.riskSummaryCitiesId ||
            (tag.id === this.riskSummaryCitiesId && this.cities))
        ) {
          if (
            this.cities?.length > 0 &&
            tag.id === this.riskSummaryCitiesId &&
            !tag.label.includes("(")
          ) {
            tag.label = tag.label + " (" + this.cities.length + ")";
          }
          return tag;
        }
      });
    },
    isWatchCountry() {
      return this.watchCountries
        .map((c) => c.properties.iso2.toLowerCase())
        .includes(this.iso2Code.toLowerCase());
    },
    countryRiskparams() {
      const riskSubCategories = lodashGet(this.params, "riskSubCategories")
        ? lodashGet(this.params, "riskSubCategories")
        : null;

      const riskPrimaryCategories =
        this.category && this.category.riskCategoryId
          ? this.category.riskCategoryId
          : null;

      const riskCategories = riskSubCategories
        ? riskSubCategories
        : riskPrimaryCategories;

      return {
        countryCode: this.selectedLocation.isoCode2,
        riskCategories: riskCategories,
      };
    },
    analysisOnly() {
      return !!(this.category && this.category.riskCategoryId);
    },
    hasMaritime() {
      // TODO: This logic can change once API is ready to get data from WB.
      return (
        this.selectedLocation?.name &&
        lodashFind(this.ratings, [
          "riskCategoryId",
          RISK_RATING_PRIMARIES.maritime,
        ])
      );
    },
    isScenariosV2FeatureUnlocked() {
      return this.featureUnlocked("risks-scenarios-v2");
    },
  },
  methods: {
    handleClickClose() {
      this.$emit(EMITTED_ACTIONS.CLICK_CLOSE);
    },
    handleClickMinimize() {
      this.$emit(EMITTED_ACTIONS.CLICK_MINIMIZE);
    },
    refreshRiskCountryHeadlineContent(expand) {
      this.refresh = expand;
    },
    handleTabChange(selectedTab, filter) {
      this.selectedTabIndex = selectedTab;
      this.selectedTabContent = filter;
    },
    handleDatesChange(dates) {
      this.selectedTabDates = dates;
    },
    handleDatesByUserChange(selectedTabDatesByUser) {
      this.selectedTabDatesByUser = selectedTabDatesByUser;
    },
    handleSortChange(sort) {
      this.selectedSort = sort;
    },
    handleClickBackToCountry() {
      this.selectedRiskSummaryType = lodashCloneDeep(
        this.filteredRiskSummaryTypes[0]
      );
      this.riskSummaryType = -1;
      this.handleChangeRiskSummaryType(this.selectedRiskSummaryType);
      this.resetExpanded = new Date().toISOString();
    },
    handleClickExpand(isExpanded) {
      this.expandedContent = isExpanded;

      if (!isExpanded) {
        document.getElementById("hyp-risk-grid").scrollTop = 0;
      }
    },
    handleClickExpandPulse() {
      this.risksPulseRatingsExpanded = true;
      this.handleClickExpand(true);
    },
    handleClickCollapsePulse() {
      this.risksPulseRatingsExpanded = false;
      this.handleClickExpand(false);
    },
    handleChangeRiskSummaryType(type) {
      this.selectedRiskSummaryType = type;
      if (this.selectedRiskSummaryType.riskRatingPrimary) {
        const rating = lodashFind(this.ratings, [
          "riskCategoryId",
          this.selectedRiskSummaryType.riskRatingPrimary,
        ]);
        this.getContent(rating, false);
        this.selectedPrimaryRiskOverview = null;
        this.category = rating;
        this.risksPulseRatingsExpanded = null;
        this.risksContentBodyExpanded = null;
        this.resetExpanded = new Date().toISOString();

        this.handlePageTrackerEvent(
          EVENT_CATEGORIES.control_risk_overview,
          EVENT_ACTIONS.clicked,
          "Country - " + this.selectedRiskSummaryType.label
        );
      } else if (
        this.selectedRiskSummaryType.id === this.riskSummaryScenarioId
      ) {
        this.handlePageTrackerEvent(
          EVENT_CATEGORIES.control_risk_scenarios,
          EVENT_ACTIONS.clicked,
          "Country Risk Scenarios"
        );
      } else if (this.selectedRiskSummaryType.id === this.riskSummaryCitiesId) {
        this.handlePageTrackerEvent(
          EVENT_CATEGORIES.control_risk_cities,
          EVENT_ACTIONS.clicked,
          "Country Risk Cities"
        );
      }
    },
    async getContent(category, isSubRisk) {
      this.showBodySections = false;
      if (this.details) {
        this.portsInfo = this.getPortsProfile();
        if (category && category.riskCategoryName) {
          if (lodashGet(this.details, "properties.formatted.riskContent")) {
            this.details.properties.formatted.riskContent.forEach((item) => {
              if (item.riskTypes) {
                if (!isSubRisk) {
                  if (
                    item.riskTypes.length === 1 &&
                    item.riskTypes[0].toLowerCase() ===
                      category.riskCategoryName.toLowerCase()
                  ) {
                    this.title =
                      category.riskCategoryName.toLowerCase() !==
                      item.title.toLowerCase()
                        ? `${category.riskCategoryNameDisplay} ${item.title}`
                        : `${category.riskCategoryNameDisplay} Overview`;
                    this.publishDate = item.publishDate;
                    this.body = item.body;
                    this.selectedPrimaryRiskOverview = lodashCloneDeep(
                      this.body
                    );
                  }
                } else {
                  const categories = lodashMap(
                    item.riskTypes,
                    lodashMethod("toLowerCase")
                  );
                  if (
                    categories.length > 1 &&
                    categories.includes(category.riskCategoryName.toLowerCase())
                  ) {
                    this.title = item.title;
                    this.publishDate = item.publishDate;
                    let body = item.body;
                    if (body === `<p style="background: white;">&nbsp;</p>`) {
                      body = this.selectedPrimaryRiskOverview;
                    }
                    this.body = body;
                  }
                }
              }
            });
          }
          this.bodyItems = null;
        } else {
          if (lodashGet(this.details, "properties.formatted.title")) {
            this.title = this.details.properties.formatted.title;
            this.mainOverview.title = this.details.properties.formatted.title;
          }
          if (lodashGet(this.details, "properties.formatted.publishDate")) {
            this.publishDate = this.details.properties.formatted.publishDate;
            this.mainOverview.publishDate = this.details.properties.formatted.publishDate;
          }
          if (lodashGet(this.details, "properties.formatted.body")) {
            this.body = this.details.properties.formatted.body;
            this.mainOverview.body = this.details.properties.formatted.body;
          }
          if (lodashGet(this.details, "properties.formatted.bodyItems")) {
            this.bodyItems = this.details.properties.formatted.bodyItems;
            this.mainOverview.bodyItems = this.details.properties.formatted.bodyItems;
          }
        }
      }
      this.showBodySections = true;
    },
    getPortsProfile() {
      return this.details?.properties?.formatted?.ports;
    },
    async getRatings() {
      this.loadingRisks = true;
      const { countries, zones } = await getRiskRatingsByCountryCode(
        this.selectedLocation.iso2Code
      );
      if (
        countries &&
        Array.isArray(countries) &&
        countries.length &&
        lodashGet(countries, "[0].properties.ratings")
      ) {
        this.ratings = countries[0].properties.ratings;
      }
      if (zones && Array.isArray(zones) && zones.length) {
        this.zones = zones;
      }
      this.loadingRisks = false;
    },
    openLocationWatch() {
      this.handleClickClose();
      let type = GRIDS_STABILITY_TYPES.country;

      this.detailsSidebar.visible = true;
      this.detailsSidebar.selected = DETAIL_SIDEBAR_TYPES.monitor;
      this.detailsSidebar.type = DETAIL_SIDEBAR_TYPES.monitor;
      this.detailsSidebar.monitorType = DETAIL_SIDEBAR_TYPES.stability;
      this.detailsSidebar.stabilityType = type;
      this.detailsSidebar.code = this.iso2Code;
      this.detailsSidebar.openMonitor = true;

      this.$store.dispatch(
        MODULE_PREFIX_HOME + GET_DETAILS_SIDEBAR,
        this.detailsSidebar
      );
    },
    hasMaritimeAccess: hasMaritimeAccess,
  },
  watch: {
    selectedLocation: {
      async handler() {
        this.riskSummaryType = -1;
        if (this.selectedLocation && this.selectedLocation.iso2Code) {
          this.selectedPrimaryRiskOverview = null;
          this.category = null;
          this.portsInfo = null;
          if (this.selectedRiskSummaryType?.id === this.riskSummaryCitiesId) {
            this.details = null;
            this.selectedRiskSummaryType = null;
          }
          await this.getRatings();
          if (this.selectedLocation.selectedPort) {
            this.selectedRiskSummaryType = lodashCloneDeep(
              lodashFind(this.filteredRiskSummaryTypes, [
                "riskRatingPrimary",
                RISK_RATING_PRIMARIES.maritime,
              ])
            );
            this.riskSummaryType = this.selectedRiskSummaryType.id;
          } else if (this.selectedLocation.selectedCity) {
            this.selectedRiskSummaryType = lodashCloneDeep(
              lodashFind(this.filteredRiskSummaryTypes, [
                "id",
                this.riskSummaryCitiesId,
              ])
            );
            this.riskSummaryType = this.selectedRiskSummaryType.id;
          } else {
            this.selectedRiskSummaryType = lodashCloneDeep(
              this.filteredRiskSummaryTypes[0]
            );
            this.riskSummaryType = -1;
          }
          this.details = await getCountryDetails(
            this.selectedLocation.iso2Code
          );
          this.handleChangeRiskSummaryType(this.selectedRiskSummaryType);
          this.risksPulseRatingsExpanded = null;
          this.risksContentBodyExpanded = null;
          this.resetExpanded = new Date().toISOString();
        }
      },
      immediate: true,
      deep: true,
    },
  },
  beforeDestroy() {
    this.selectedPrimaryRiskOverview = null;
  },
};
</script>

<style>
.content-container img {
  max-width: 460px;
}
</style>

<style scoped>
.hyp-risk-details-container {
  --full-height: 100vh - 24px - 40px - 48px; /* top padding - page header - r&s tabs */
  --pulse-heights: 27%, 265px;
  --overview-height: min(25%, 225px);
  margin: 0;
  padding: 0;
  max-width: unset !important;
  line-height: 1.5;
  height: calc(var(--full-height));
}
.hyp-risk-details-container > *,
.hyp-risk-details-container > * > *,
.hyp-risk-tab-items > *,
.hyp-risk-grid-left {
  height: 100%;
}
.hyp-risk-tab-items {
  overflow-y: auto;
  padding-top: 0;
  padding-bottom: 0;
  max-width: unset !important;
  height: 100%;
}
.hyp-risk-tabs {
  text-transform: capitalize;
}

.hyp-risk-details-container .theme--light.v-tabs-items {
  background-color: unset;
}
#hyp-risk-grid {
  height: calc(var(--full-height) - 12px);
  display: grid;
  grid-template-columns: 50% 50%;
  overflow-x: auto;
  overflow-y: hidden;
}
#hyp-risk-grid > .col {
  height: calc(var(--full-height) - 15px);
}
#hyp-risk-grid > .col:nth-child(2) {
  display: grid;
  padding-top: 0;
  padding-left: 0;
  grid-template-rows: minmax(var(--pulse-heights)) var(--overview-height) 1fr;
}
@media screen and (min-width: 1580px) {
  #hyp-risk-grid > .col:nth-child(2) {
    grid-template-rows: minmax(27%, 245px) var(--overview-height) 1fr;
  }
}
@media screen and (min-width: 1580px) {
  .expanded-content #hyp-risk-grid > .col:nth-child(2) {
    grid-template-rows: minmax(27%, 245px) auto 400px;
  }
}
.expanded-content {
  padding-bottom: 20px;
}
.expanded-content #hyp-risk-grid {
  overflow-y: auto;
}
#hyp-risk-grid > .col:nth-child(2) > *:last-child {
  min-height: 1px; /* Prevent grid blowout */
  margin-bottom: 0 !important;
}
.selected-Political-Risk #hyp-risk-grid > .col:nth-child(2),
.selected-Maritime-Risk #hyp-risk-grid > .col:nth-child(2),
.selected-Operational-Risk #hyp-risk-grid > .col:nth-child(2),
.selected-Cyber #hyp-risk-grid > .col:nth-child(2) {
  grid-template-rows: minmax(var(--pulse-heights)) 1fr;
}
.selected-Security-Risk #hyp-risk-grid > .col:nth-child(2) {
  grid-template-rows: minmax(var(--pulse-heights)) var(--overview-height) 1fr;
}
.expanded-content .selected-Overview #hyp-risk-grid > .col:nth-child(2),
.expanded-content .selected-Security-Risk #hyp-risk-grid > .col:nth-child(2) {
  grid-template-rows: min(var(--pulse-heights)) auto 400px;
  height: auto;
}
.has-ports.selected-Maritime-Risk #hyp-risk-grid {
  height: 100%;
  overflow-y: auto;
}
.has-ports.selected-Maritime-Risk #hyp-risk-grid > .col:nth-child(2) {
  grid-template-rows: minmax(var(--pulse-heights)) min(25%, 200px) 1fr;
  height: auto;
}
.has-ports.selected-Maritime-Risk
  #hyp-risk-grid
  > .col:nth-child(2)
  > *:last-child {
  min-height: unset;
}
</style>
